import * as React from "react";
import { CopyButtonWithApproval } from "./copyButtonWithApproval";

interface Props {
  small?: boolean;
  value: string;
}

export const DomainDryRunConfigItem: React.FC<Props> = ({ small = false, value }) => {
  return (
    <div className={`flex items-center gap-1 ${small ? `col-span-1` : `col-span-3`} dryRunConfigItem`}>
      <span>{value}</span>
      <CopyButtonWithApproval value={value} />
    </div>
  );
};
